import React, { createContext, useContext, useState } from 'react'

type CurrentStepContextType = {
  currentStep: number
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>
}

const CurrentStepContext = createContext<CurrentStepContextType | undefined>(
  undefined
)

export const CurrentStepProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const [currentStep, setCurrentStep] = useState<number>(1)
  return React.createElement(
    CurrentStepContext.Provider,
    { value: { currentStep, setCurrentStep } },
    children as any
  )
}

export const useCurrentStep = () => {
  const ctx = useContext(CurrentStepContext)
  // Fallback to local state when no provider is mounted (to avoid crashes on other pages)
  const [fallbackStep, setFallbackStep] = useState<number>(1)
  return ctx ?? { currentStep: fallbackStep, setCurrentStep: setFallbackStep }
}
